import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PageModal from '../common/PageModal'
import SimpleButton from '../common/SimpleButton'
import { toast } from '../common/Toast'
import { no_image_200x200 } from '../../images'
import '../Uploads/uploads.scss'
import './view-sparepart-image-modal.scss'

const formatBytes = (bytes) => {
  const n = Number(bytes || 0)
  if (!n) return '-'
  const k = 1024
  const units = ['B', 'KB', 'MB', 'GB']
  const i = Math.min(Math.floor(Math.log(n) / Math.log(k)), units.length - 1)
  const v = n / Math.pow(k, i)
  return `${v >= 10 || i === 0 ? Math.round(v) : v.toFixed(1)} ${units[i]}`
}

const ViewSparePartImageModal = (props) => {
  const { t } = useTranslation()
  const { sparePart, closeModal } = props

  const imageSrc = sparePart?.src || no_image_200x200
  const hasImage = !!sparePart?.src

  const title = useMemo(() => sparePart?.item_id || sparePart?.description || '-', [sparePart])

  const sizeLabel = formatBytes(sparePart?.fileSize)
  const dimsLabel = sparePart?.width && sparePart?.height ? `${sparePart.width} x ${sparePart.height}` : '-'

  const downloadName = sparePart?.filename || sparePart?.item_id || 'sparepart-image'

  const handleDownload = async () => {
    if (!hasImage) return
    try {
      const res = await fetch(sparePart.src, { mode: 'cors', cache: 'no-store' })
      if (!res.ok) throw new Error(`Unexpected response ${res.status}`)
      const blob = await res.blob()
      const blobUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = downloadName
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(blobUrl)
      toast.success(t('spareparts.image_downloaded_success'))
    } catch {
      toast.error(t('error.something_wrong'))
    }
  }

  return (
    <PageModal
      toggle
      onToggle={closeModal}
      className="uploads-modal model-image-view-modal sparepart-image-view-modal"
      footerContent={
        <div className="footer-content">
          <div className="d-flex flex-align-center flex-justify-start">
            <div className="meta">
              <div className="name" title={title}>
                {String(title).toUpperCase()}
              </div>
              {(sizeLabel !== '-' || dimsLabel !== '-') && (
                <div className="sub">
                  {sizeLabel !== '-' && <span>{sizeLabel}</span>}
                  {sizeLabel !== '-' && dimsLabel !== '-' && <span className="dot">•</span>}
                  {dimsLabel !== '-' && <span>{dimsLabel}</span>}
                </div>
              )}
            </div>
            {/* <TooltipedIcon icon={<InformationIcon />} tooltipText={`${t('product_models_context.image_meta_info')}`} /> */}
          </div>
          <SimpleButton className="submit-button" onClick={handleDownload} disabled={!hasImage}>
            {t('download')}
          </SimpleButton>
        </div>
      }
    >
      <div className="uploads-modal-content content">
        <div className="canvas">
          <img className="img" src={imageSrc} alt={String(title)} />
        </div>
      </div>
    </PageModal>
  )
}

export default ViewSparePartImageModal
